import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { KriComponent } from './kri.component';
import { MisKriComponent } from './mis-kri.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { AddKriDialogBoxComponent} from './dialog/add-kri-dialog-box.component';
import { MedicionesListComponent} from './dialog/mediciones-list.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatTabsModule} from '@angular/material/tabs';
import { ChartsModule } from 'ng2-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DialogBoxPrintComponentKri } from './dialog/dialog-print-box.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FiltrosKRIComponent } from './dialog/filtros.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';


@NgModule({
    declarations: [
        KriComponent,
        MedicionesListComponent,
        AddKriDialogBoxComponent,
        MisKriComponent,
        DialogBoxPrintComponentKri,
        FiltrosKRIComponent
    ],
    imports     : [
        BrowserAnimationsModule,
        FormsModule,
        MatTableModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatChipsModule,
        FuseSharedModule,
        MatIconModule,
        MatAutocompleteModule,
        TranslateModule,
        MatDatepickerModule,
        MatTabsModule,
        ChartsModule,
        NgxChartsModule,
        MatSidenavModule,
        MatPaginatorModule,
        MatCardModule    
    ],
    entryComponents: [
        MedicionesListComponent,
        AddKriDialogBoxComponent,
        MisKriComponent,
        DialogBoxPrintComponentKri,
        FiltrosKRIComponent
    ],
    exports: [MedicionesListComponent,
              FiltrosKRIComponent
            ]
})
export class KriModule
{
}
